// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainTopNav {
  background-color: #f8f9fa !important;
  height: 65px;
  transition: all 0.3s ease;
  z-index: 1040;
}

.navbar-brand-img {
  height: 35px;
  width: auto;
}

.sidenav {
  width: 240px;
  transition: all 0.3s ease;
  height: calc(100vh - 60px);
  position: fixed;
  top: 60px;
  left: 0;
  overflow-y: auto;
  z-index: 1020;
  background-color: #fff;
  padding: 20px 0 0 0;
}

.sidenav.collapsed {
  width: 80px;
}

.sidenav .nav-link {
  color: #5e72e4;
  font-weight: 500;
  padding: 10px 15px;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease;
}

.sidenav .nav-link:hover,
.sidenav .nav-link.active {
  background: #f6f9fc;
  color: #172b4d;
}

.sidenav .sidebar-footer {
  border-top: 1px solid #e9ecef;
  background: #fff;
}

.sidenav.collapsed .nav-link-text {
  display: none;
}

.sidenav.collapsed .nav-link i {
  margin-right: 0;
  font-size: 1.2rem;
}
.sidebar-footer {
  border-top: 1px solid #e9ecef; 
  width: 100%; 
  padding: 1rem 1rem 0.5rem 1rem; 
  margin-top: auto;
  background-color: #fff; 
}

.main-content{
    background-color: #eee;
    padding: 25px 10px;
    margin: 60px 0 0 0;
    /* width: 100%; */
    height: 100%;
}

.bg-purple {
  background-color: #6f42c1 !important; 
}

.avatar-circle{
border-radius: 100%;
    height: 35px;
    width: 35px;
    align-items: center;
    display: flex;
    /* text-align: center; */
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/custom.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;AACA,mBAAmB;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,wBAAwB;IACxB,uBAAuB;AAC3B","sourcesContent":[".mainTopNav {\n  background-color: #f8f9fa !important;\n  height: 65px;\n  transition: all 0.3s ease;\n  z-index: 1040;\n}\n\n.navbar-brand-img {\n  height: 35px;\n  width: auto;\n}\n\n.sidenav {\n  width: 240px;\n  transition: all 0.3s ease;\n  height: calc(100vh - 60px);\n  position: fixed;\n  top: 60px;\n  left: 0;\n  overflow-y: auto;\n  z-index: 1020;\n  background-color: #fff;\n  padding: 20px 0 0 0;\n}\n\n.sidenav.collapsed {\n  width: 80px;\n}\n\n.sidenav .nav-link {\n  color: #5e72e4;\n  font-weight: 500;\n  padding: 10px 15px;\n  border-radius: 8px;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.sidenav .nav-link:hover,\n.sidenav .nav-link.active {\n  background: #f6f9fc;\n  color: #172b4d;\n}\n\n.sidenav .sidebar-footer {\n  border-top: 1px solid #e9ecef;\n  background: #fff;\n}\n\n.sidenav.collapsed .nav-link-text {\n  display: none;\n}\n\n.sidenav.collapsed .nav-link i {\n  margin-right: 0;\n  font-size: 1.2rem;\n}\n.sidebar-footer {\n  border-top: 1px solid #e9ecef; \n  width: 100%; \n  padding: 1rem 1rem 0.5rem 1rem; \n  margin-top: auto;\n  background-color: #fff; \n}\n\n.main-content{\n    background-color: #eee;\n    padding: 25px 10px;\n    margin: 60px 0 0 0;\n    /* width: 100%; */\n    height: 100%;\n}\n\n.bg-purple {\n  background-color: #6f42c1 !important; \n}\n\n.avatar-circle{\nborder-radius: 100%;\n    height: 35px;\n    width: 35px;\n    align-items: center;\n    display: flex;\n    /* text-align: center; */\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
